import React, { Component, useEffect } from "react";
import { Router } from "next/router";
import posthog from "posthog-js";

/** These SiteApp need to be converted to modules: */
import "../form/playVideoForm/EmbedVideoModal.css";
import "../form/createAccountForm/BasicInfoStep.css";
import "../form/forgotPasswordForm/ForgotPasswordModal.css";

/** These WebApp need to be converted to modules: */
import "../form/formModal.css";
import "../form/form.css";
import "../pixelmixer-webapp/src/component/loader/Loader.css";
import "../pixelmixer-webapp/src/component/loader/LoaderSmall.css";
import "../pixelmixer-webapp/src/component/pinInput/PinInput.css";
import "../pixelmixer-webapp/src/component/loader/Checkmark.css";

import Layout from "../component/layout/Layout";
import { initPostHog } from "../pixelmixer-webapp/src/util/Utils";

const NextApp = ({ Component, pageProps }) => {
  useEffect(() => {
    initPostHog();
    const handleRouteChange = () => posthog?.capture("$pageview");
    Router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <Layout>
      <Component {...pageProps} />
    </Layout>
  );
};

export default NextApp;
